import React from "react";
import {FC} from "react";
import DtoTable from "../../components/dto-table/dto-table";
import CustomerOrderModel from "../../models/dto/customer-order-model";
import useSafeState from "../../utils/safe-state";
import {Breadcrumb, Button, Space, Tooltip, Modal, InputNumber, Popover, Table, message, List} from "antd";
import {Trans} from "@lingui/macro";
import {useAxios} from "../../utils/hooks";
import {EditTwoTone, FileImageTwoTone, PlusOutlined, PrinterOutlined, QrcodeOutlined, DeleteOutlined} from "@ant-design/icons";
import {RightOutlined, SnippetsOutlined} from "@ant-design/icons/lib";
import {useKeycloak} from "@react-keycloak/web";
import {Column} from "#/models/column";
import OrderDrawer from "../../forms/order-form/order-drawer";
import Drawer from "../../components/drawer/drawer";
import FileDownload from "js-file-download";
import {antdContext} from "../../utils/antdContext";
import {AxiosError, AxiosResponse} from 'axios';
import flatten from "flat";
import i18next from "i18next";
import _ from 'lodash';
import {openNotification} from "../../utils/openNotification";

const CustomerOrderScreen : FC = () => {

    const {initialized, keycloak} = useKeycloak();

    const [trigger, setTrigger] = useSafeState(false);

    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL  + "");
    const [isModalVisible, setIsModalVisible] = useSafeState(false);
    const [actQty, setActQty] = useSafeState(0);
    const [actProduct, setActProduct] = useSafeState<any>();
    const [deliveryNoteData, setDeliveryNoteData] = useSafeState<Array<any>>([]);
    const [maxQty, setMaxQty] = useSafeState<any>();
    const [visible, setVisible] = useSafeState(false);
    const qtyText = <Trans>Quantity</Trans>
    const text = <Trans>Customer Order</Trans>
    const drawer = Drawer(
        {
            title: text,
            children:
                <OrderDrawer/>,
            customClose: () => setTrigger(!trigger)
        }
    );

    const isAllowed = (): boolean => {

        let sumQty = 0;
        for (let i = 0; i < deliveryNoteData.length; i++) {
            if(
                deliveryNoteData[i].productCode == actProduct.productCode &&
                deliveryNoteData[i].lotNumber == actProduct.lotNumber
            ){
                sumQty += deliveryNoteData[i].quantity;
            }
        }
        console.log(sumQty, actQty, maxQty);
        return sumQty + actQty <= maxQty;
    }

    const handleOk = () => {
        if(actQty > 0 && actQty <= maxQty && isAllowed()){
            setIsModalVisible(false);
            actProduct.quantity = actQty;
            setDeliveryNoteData([...deliveryNoteData,
                {
                    key: (deliveryNoteData.length + 1).toString(),
                    productCode: actProduct.productCode,
                    lotNumber: actProduct.lotNumber,
                    quantity: actQty,
                    
                }
            ]);
            setVisible(true);
        }
    };

    const actions = {
        width: 50,
        render: (text: string, record: any) => action(text, record),
        title: '',
        fixed: 'right',
        align: 'center'
    };

    const showModal = (record: any) => {
        setIsModalVisible(true);
        setActQty(record.orderedQuantity > 0 ? record.orderedQuantity : 0);
        setMaxQty(record.orderedQuantity > 0 ? record.orderedQuantity : 0);
        setActProduct(
            {
                productCode: record.id.productCode,
                lotNumber: record.id.lotNumber,
                orderedQuantity: record.orderedQuantity,
                
            }

        );
    };

    const action = (text: string, record: any) => {

        return  <>
            
            <Tooltip placement="top" title={<Trans>Add to Delivery Note</Trans>}>
                <RightOutlined
                    className={"ActionButtons"}
                    style={{color: "#40a9ff"}}
                    onClick={() => showModal(record)
                    }
                />
            </Tooltip>
        </>
    }

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleOnPrint = () => {
        if(axiosInstance.current != null){

            const FileDownload = require('js-file-download');

            axiosInstance
                .current({
                    url: process.env.REACT_APP_API_BASE_URL + '/resource/delivery-notes/create-deliv-note-by-customer-order',
                    method: 'POST',
                    responseType: 'blob',
                    data: deliveryNoteData
                })
                .then(response => {
                    console.log(response);
                    FileDownload(response.data, 'deliv_note.pdf');
                    setDeliveryNoteData(new Array());
                    setVisible(false);
                })
                .catch(async (error: any) => {
                    if (
                        error &&
                        error.response &&
                        error.response.data &&
                        error.response.data instanceof Blob
                    ) {
                        const text = await error.response.data.text();
                        const json = JSON.parse(text);

                        openNotification('error', {
                            ...error,
                            response: {
                                ...error.response,
                                data: json
                            }
                        });
                    } else {
                        openNotification('error', error);
                    }
                });
        }
    };

    function showActionError(error: AxiosError<ActionError | ActionError[]>) {
        const response = getResponse(error);

        const content = Array.isArray(response.data) ? (
            <List dataSource={response.data} renderItem={renderListItem} size="small" />
        ) : (
            console.log(response.data.defaultMessage)
        );
    }

    function getResponse(error: AxiosError<ActionError | ActionError[]>): AxiosResponse<ActionError | ActionError[]> {
        if (error.response) {
            return error.response;
        }
        throw new Error();
    }

    interface ActionError {
        messageKey: string;
        defaultMessage: string;
        body?: any;
        cause?: any;
    }

    function renderListItem(error: ActionError) {
        return <List.Item>{renderActionError(error)}</List.Item>;
    }

    function renderActionError(error: ActionError) {
        const flatBody: any = error.body && flatten(error.body, { safe: true });
        window.console.debug('ACTION_ERROR', flatBody);

        //const msg = i18next._(error.messageKey, flatBody);

        return (
            <>
                {parseMessage(error.defaultMessage, flatBody)}
            </>
        );
    }

    function parseMessage(str: string, data: object) {
        return (
            str &&
            str.replace(/\${([^}]+)}/g, (substring, key) => {
                const result = _.get(data, key);
                return result || substring;
            })
        );
    }

    const hide = () => {
        setVisible(false);
    };

    const handleVisibleChange = (newVisible: boolean) => {
        setVisible(newVisible);
    };

    const delivNoteTitleText = <h2><Trans>Delivery Note</Trans></h2>

    const columns : Array<Column> = new Array();

    columns.push({key:'product',dataIndex:["productCode"], width: 150, direction: "asc", fixed: "left", sorter:false, title:<Trans>Product</Trans>});
    columns.push({key:'lotNumber', dataIndex:["lotNumber"], width: 150, sorter:false,title:<Trans>Lot Number</Trans>});
    columns.push({key:'quantity',dataIndex:["quantity"], width: 150, sorter:false,title:<Trans>Quantity</Trans>});

    columns.push(
        {
            key: 'action',
            sorter: false,
            width: 50,
            title: <></>,
            render: (_, record) => (
                <Space size="middle">
                    <DeleteOutlined className={"ActionButtons"} style={{color: "#ff4d4f"}} onClick={() => {
                        const newData = deliveryNoteData.filter(item => item.key !== record.key);
                        setDeliveryNoteData(newData);
                    }
                    }/>
                </Space>
            ),
        }
    );

    return  <>
        <Breadcrumb style={{ marginBottom: 10 }}>
            <Breadcrumb.Item><Trans id={'Homepage'}/></Breadcrumb.Item>
            <Breadcrumb.Item><Trans id={'Customer Orders'}></Trans></Breadcrumb.Item>
        </Breadcrumb>
        <DtoTable
        tableHeader={
            <>
                <Popover
                    content={
                        <>
                            <Table columns={columns} dataSource={deliveryNoteData} bordered/>
                            <br />
                            <a onClick={hide}><Trans>Close</Trans></a>
                            <a style={{float: "right" }} onClick={() =>
                                handleOnPrint()
                            }><Trans>Print</Trans></a>
                        </>
                    }
                    title={delivNoteTitleText}
                    trigger="click"
                    visible={visible}
                    onVisibleChange={handleVisibleChange}
                >
                    <Button type="primary" style={{float: "right" }}><SnippetsOutlined /><span><Trans>Delivery Note</Trans></span></Button>
                </Popover>
            </>
        }
            model={CustomerOrderModel}
            trigger={trigger}
            allowRefreshButton={true}
            action={actions}
            pageSize={100}
            scroll={{ x: 1300, y: "60vh" }}
        />
        <Modal title={qtyText} visible={isModalVisible} onOk={handleOk}
               onCancel={handleCancel} width={230}>
            <InputNumber value={actQty}
                         onInput={
                             (value) => {
                                 value <= maxQty ? setActQty(Number(value)) : setActQty(0);
                             }
                         }
                         onStep={
                             (value) => {
                                 value <= maxQty ? setActQty(value) : setActQty(0);
                             }
                         }

                         min={0} max={maxQty} style={{width: "100%"}}/>

            <span style={{color: "red", fontStyle: "italic"}}><Trans>Available max. quantity: {maxQty}</Trans></span>
        </Modal>
        {drawer.component}
    </>
}
export default CustomerOrderScreen;
